import { formatDate } from './date';

// Kept as the historical name for `formatDate`. See ./date.js for why calendar dates
// must not be re-interpreted in the viewer's timezone.
export default (date, format) => formatDate(date, format);
